export default __webpack_public_path__ + "29f0550bed11703a546f29d044347d16.svg";